<nb-card>
  <nb-card-header [nbSpinner]="loading" nbSpinnerStatus="info">
    <button
      nbButton
      outline
      shape="semi-round"
      status="primary"
      size="small"
      (click)="onNew()"
      [disabled]="loading"
      [class.btn-pulse]="loading"
    >
      <span>{{ "buttons.create" | translate }}</span>
    </button>

    <button
      nbButton
      outline
      shape="semi-round"
      status="success"
      size="small"
      (click)="printProducts()"
      [disabled]="loading"
      [class.btn-pulse]="loading"
    >
      <nb-icon icon="printer-outline"></nb-icon>
      <span>{{ "buttons.printProducts" | translate }}</span>
    </button>
  </nb-card-header>

  <nb-card-body>
    <div class="table-responsive">
      <ng2-smart-table
        [settings]="settings"
        [source]="source"
        (createConfirm)="onCreateConfirm($event)"
        (editConfirm)="onSaveConfirm($event)"
        (deleteConfirm)="onDeleteConfirm($event)"
        (userRowSelect)="selectedProduct($event)"
      >
      </ng2-smart-table>
      <strong class="text-hint">Tổng số: {{ source.count() }}</strong>
    </div>
  </nb-card-body>
</nb-card>
